import { render, staticRenderFns } from "./GlobientCustomerInfo.vue?vue&type=template&id=24be48de&"
import script from "./GlobientCustomerInfo.vue?vue&type=script&lang=js&"
export * from "./GlobientCustomerInfo.vue?vue&type=script&lang=js&"
import style0 from "./GlobientCustomerInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports